"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _DatePicker = require("./DatePicker.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 日期組件
 */
const {
  RangePicker
} = _antd.DatePicker;
const DatePicker = _ref => {
  let {
    defaultValue,
    variant,
    onChange
  } = _ref;
  const onDateChange = (date, dateString) => {
    onChange && onChange(date, dateString);
  };
  return /*#__PURE__*/_react.default.createElement(_DatePicker.UiDatePicker, {
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(RangePicker, {
    defaultValue: defaultValue,
    onChange: (date, dateString) => {
      onDateChange(date, dateString);
    }
  }));
};
var _default = exports.default = DatePicker;
DatePicker.propTypes = {
  defaultValue: _propTypes.default.array,
  variant: _propTypes.default.string,
  onChange: _propTypes.default.func
};